import * as React from 'react';
import { SVGProps } from 'react';

const SvgClipboard = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
    <path d="M4 6h2v3h10V6h2v5h2V6c0-1.1-.9-2-2-2h-4.18C13.4 2.84 12.3 2 11 2s-2.4.84-2.82 2H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h6v-2H4V6zm7-2c.55 0 1 .45 1 1s-.45 1-1 1-1-.45-1-1 .45-1 1-1zm3.51 14L20 12.5l1.5 1.5-6.99 7L10 16.5l1.5-1.5 3.01 3z" />
  </svg>
);

export default SvgClipboard;
